<template>
    <base-select-filter-conditions
        :value="value"
        :form-name="formName"
        :options="options"
        @input="$emit('input', $event)"
    />
</template>

<script>
import BaseSelectFilterConditions
    from "$flx/components/abstract-search/filters/conditions/components/BaseSelectFilterConditions";
export default {
    inject : ['$validator'],
    components : {BaseSelectFilterConditions},
    props : {
        value : {
        },
        formName : {
            type : String,
            required : true,
        },
    },
    computed : {
        options () {
            return [
                {
                    value : 'list_is_empty',
                    label : 'Has None',
                },
                {
                    value : 'list_not_empty',
                    label : 'Has At Least One',
                },
            ];
        },
        selectedOption () {
            return this.options.find(o => o.value === this.value.value);
        },
    },
    methods : {
        getLabel () {
            return `${this.selectedOption.label}`;
        },
    }
}
</script>

<style scoped>
</style>
